<template>
    <div class="answers" :class="getAnswersPosition">
        <app-answer
            v-for="(answer, index) in answers"
            :id="answer.id"
            :variation="variation"
            :body="answer.name"
            :image="answer.image"
            :key="index"
            :showFeedback="isAnswered"
            :selectedID="givenAnswer"
            :correctID="getCorrectAnswer"
            :isAnimating="isAnimating"
            :x="getX(index)"
            :y="getY(index)"
            :gameType="gameType"
            :answeredCorrect="answeredCorrect"
        ></app-answer>
    </div>
</template>

<script>
import Answer from "./Answer.vue";
export default {
    name: "Answers",
    components: {
        appAnswer: Answer
    },
    props: {
        index: {
            type: Number,
            default: 0
        },
        answers: {
            type: Array,
            required: true
        },
        variation: {
            type: Number,
            default: 0
        },
        isAnswered: {
            type: Boolean,
            default: false
        },
        givenAnswer: {
            type: Number,
            default: 0
        },
        correctAnswer: {
            type: Number,
            default: 0
        },
        isAnimating: {
            type: Boolean,
            default: false
        },
        gameType: {
            type: String,
            default:"fruitmachine"
        },
        feedbackVisible: {
            type:Boolean,
            default:false
        },
        answeredCorrect: {
            type:Boolean,
            default: false
        }
    },
    methods: {
        getX(index) {
            if (index == 0 || index == 2) {
                return 0;
            } else {
                return 1;
            }
        },
        getY(index) {
            if (index == 2 || index == 3) {
                return 1;
            } else {
                return 0;
            }
        }
    },
    computed: {
        getAnswersPosition() {
            if(this.gameType =="fruitmachine") {
                return ""
            } else {
                 return "answersLow"
            }
        },
        getCorrectAnswer() {
            return this.correctAnswer
        }
    }
};
</script>

<style scoped>
.answers {
    position: absolute;
    top: 50%;
    z-index: 5;
    height: 35%;
    width: 100%;
    width:100%;
}
.answersLow {
    top:35%;
}
</style>
